import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '../../../../components/MobileMenu/components/SubItem/components/Container.js';
import { MaskedLink } from '../../../../components/internal/MaskedLink/index.js';
export const SubItem = ({
  href,
  children,
  masked,
  target = '_blank'
}) => masked ? _jsx(MaskedLink, {
  href: href,
  target: target,
  rel: "noreferrer",
  children: _jsx(Container, {
    as: "span",
    children: children
  })
}) : _jsx(Container, {
  href: href,
  target: target,
  rel: "noreferrer",
  children: children
});